(function () {
  'use strict';

  function normalise(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function money(cents, currency, locale) {
    try {
      return new Intl.NumberFormat(locale || 'en-GB', {
        style: 'currency',
        currency: currency || 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '£' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function getVariantOption(variant, index) {
    if (!variant) return '';
    if (Array.isArray(variant.options)) return variant.options[index] || '';
    return variant['option' + (Number(index) + 1)] || '';
  }

  function initServiceSelector(root) {
    if (!root || root.dataset.rmxInitialised === 'true') return;
    root.dataset.rmxInitialised = 'true';

    var section = root.closest('[data-rmx-product-section]');
    var form = root.closest('form');
    var variantsScript = root.querySelector('[data-rmx-variants-json]');
    var variants = [];
    try { variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]') || []; } catch (error) { variants = []; }

    var serviceOptionIndex = Number(root.dataset.serviceOptionIndex || -1);
    var serviceCount = Number(root.dataset.serviceCount || 0);
    var vatRate = Number(root.dataset.vatRate || 0.2);
    var currency = root.dataset.currency || 'GBP';
    var locale = root.dataset.locale || 'en-GB';
    var requireRepairConfirm = root.dataset.requireRepairConfirm === 'true';
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var quantityInput = form ? form.querySelector('[data-rmx-quantity-input]') : null;
    var addButton = form ? form.querySelector('[data-rmx-add-button]') : null;
    var addLabel = addButton ? addButton.querySelector('[data-rmx-add-label]') : null;
    var confirmWrap = root.querySelector('[data-rmx-repair-confirm]');
    var confirmInput = confirmWrap ? confirmWrap.querySelector('[data-rmx-repair-confirm-input]') : null;
    var confirmationProperty = root.querySelector('[data-rmx-property-confirmation]');
    var serviceCards = Array.prototype.slice.call(root.querySelectorAll('[data-rmx-service-card]'));
    var optionSelects = Array.prototype.slice.call(root.querySelectorAll('[data-rmx-option-select]'));
    var optionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rmx-option-button]'));
    var selectionText = root.querySelector('[data-rmx-selection-text]');
    var selectionPrice = root.querySelector('[data-rmx-selection-price]');
    var priceMain = section ? section.querySelector('[data-rmx-price-main]') : null;
    var priceInc = section ? section.querySelector('[data-rmx-price-inc]') : null;
    var stock = section ? section.querySelector('[data-rmx-stock]') : null;
    var sku = section ? section.querySelector('[data-rmx-sku]') : null;
    var collectionWrap = form ? form.querySelector('[data-rmx-collection-wrap]') : null;
    var galleryRoute = section ? section.querySelector('[data-rmx-gallery-route]') : null;
    var galleryRouteIcons = section ? Array.prototype.slice.call(section.querySelectorAll('[data-rmx-gallery-route-icon]')) : [];
    var processRoutes = section ? Array.prototype.slice.call(section.querySelectorAll('[data-rmx-process-route]')) : [];
    var extraOptionsWrap = root.querySelector('[data-rmx-extra-options]');
    var optionVisibilityScope = root.dataset.optionVisibilityScope || 'all';
    var enhancedRepairOptions = root.dataset.enhancedRepairOptions === 'true';
    var repairOptionLabel = root.dataset.repairOptionLabel || '';
    var exchangeLookup = root.querySelector('[data-rmx-exchange-lookup]');
    var exchangeGroupsScript = root.querySelector('[data-rmx-exchange-groups-json]');
    var exchangeGroups = [];
    try { exchangeGroups = JSON.parse(exchangeGroupsScript ? exchangeGroupsScript.textContent : '[]') || []; } catch (error) { exchangeGroups = []; }
    var lookupInput = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-lookup-input]') : null;
    var lookupToggle = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-lookup-toggle]') : null;
    var lookupSuggestions = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-suggestions]') : null;
    var lookupSuggestionList = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-suggestion-list]') : null;
    var lookupStatus = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-status]') : null;
    var lookupControl = exchangeLookup ? exchangeLookup.querySelector('.rmx-exchange-lookup__control') : null;
    var selectionDetails = root.querySelector('[data-rmx-selection-details]');
    var selectionReference = root.querySelector('[data-rmx-selection-reference]');
    var selectionSystem = root.querySelector('[data-rmx-selection-system]');
    var selectionAsd = root.querySelector('[data-rmx-selection-asd]');
    var selectionNumbersWrap = root.querySelector('[data-rmx-selection-numbers-wrap]');
    var selectionNumbers = root.querySelector('[data-rmx-selection-numbers]');
    var lookupPropertyGroup = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-property-group]') : null;
    var lookupPropertyReference = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-property-reference]') : null;
    var lookupPropertyDetail = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-property-detail]') : null;
    var lookupPropertyAsd = exchangeLookup ? exchangeLookup.querySelector('[data-rmx-exchange-property-asd]') : null;
    var lookupRequired = Boolean(exchangeLookup && exchangeGroups.length);
    var selectedLookupGroup = null;
    var selectedLookupReference = '';
    var selectedVariant = null;

    function selectedCard() {
      return serviceCards.find(function (card) { return card.classList.contains('is-active'); }) || serviceCards[0] || null;
    }

    function currentService() {
      var card = selectedCard();
      return card ? (card.dataset.service || 'repair') : (root.dataset.defaultService || 'repair');
    }

    function serviceValue(service) {
      var card = serviceCards.find(function (candidate) { return candidate.dataset.service === service; });
      return card ? (card.dataset.value || '') : '';
    }

    function serviceLabel(service) {
      var card = serviceCards.find(function (candidate) { return candidate.dataset.service === service; });
      var label = card ? card.querySelector('.rmx-service-card__copy strong') : null;
      if (label) return label.textContent.trim();
      if (service === 'exchange') return root.dataset.exchangeButtonText ? 'Exchange unit' : 'Exchange service';
      if (service === 'standard') return 'Product';
      return 'Repair service';
    }

    function selectionsObject(service) {
      var selected = {};
      if (enhancedRepairOptions && service === 'exchange') return selected;
      if (optionVisibilityScope === 'exchange' && service !== 'exchange') return selected;
      optionSelects.forEach(function (select) {
        selected[Number(select.dataset.optionIndex)] = select.value;
      });
      return selected;
    }

    function updateExtraOptionsVisibility(service) {
      if (!extraOptionsWrap) return;
      var visible = enhancedRepairOptions
        ? service !== 'exchange'
        : (optionVisibilityScope !== 'exchange' || service === 'exchange');
      extraOptionsWrap.hidden = !visible;
      extraOptionsWrap.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function selectForIndex(index) {
      return optionSelects.find(function (select) {
        return Number(select.dataset.optionIndex) === Number(index);
      }) || null;
    }

    function syncOptionButtons() {
      optionButtons.forEach(function (button) {
        var select = selectForIndex(button.dataset.optionIndex);
        var option = select ? Array.prototype.find.call(select.options, function (candidate) {
          return normalise(candidate.value) === normalise(button.dataset.value);
        }) : null;
        var active = Boolean(select && normalise(select.value) === normalise(button.dataset.value));
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = !option || option.disabled;
        button.dataset.unavailable = button.disabled ? 'true' : 'false';
      });
    }

    function matchesService(variant, service) {
      if (!variant) return false;
      if (serviceOptionIndex < 0) return true;
      var route = normalise(getVariantOption(variant, serviceOptionIndex));
      if (service === 'repair') return route.indexOf('repair') !== -1;
      if (service === 'exchange') return route.indexOf('exchange') !== -1 || route.indexOf('replacement') !== -1;
      var expected = normalise(serviceValue(service));
      return !expected || route === expected;
    }

    function matchesSelections(variant, selections, ignoredIndex) {
      return Object.keys(selections).every(function (index) {
        if (Number(index) === Number(ignoredIndex)) return true;
        return normalise(getVariantOption(variant, Number(index))) === normalise(selections[index]);
      });
    }

    function exactVariant(service, selections) {
      return variants.find(function (variant) {
        return matchesService(variant, service) && matchesSelections(variant, selections, -999);
      }) || null;
    }

    function scoreVariant(variant, selections) {
      return Object.keys(selections).reduce(function (score, index) {
        return score + (normalise(getVariantOption(variant, Number(index))) === normalise(selections[index]) ? 1 : 0);
      }, 0);
    }

    function bestVariant(service, selections, changedIndex) {
      var exact = exactVariant(service, selections);
      if (exact) return exact;

      var candidates = variants.filter(function (variant) { return matchesService(variant, service); });
      if (changedIndex != null && selections[changedIndex] != null) {
        var changedMatches = candidates.filter(function (variant) {
          return normalise(getVariantOption(variant, Number(changedIndex))) === normalise(selections[changedIndex]);
        });
        if (changedMatches.length) candidates = changedMatches;
      }

      candidates.sort(function (a, b) {
        var availability = Number(b.available !== false) - Number(a.available !== false);
        if (availability) return availability;
        return scoreVariant(b, selections) - scoreVariant(a, selections);
      });
      return candidates[0] || variants.find(function (variant) { return variant.available !== false; }) || variants[0] || null;
    }

    function syncSelectsToVariant(variant) {
      if (!variant) return;
      optionSelects.forEach(function (select) {
        var value = getVariantOption(variant, Number(select.dataset.optionIndex));
        if (value && Array.prototype.some.call(select.options, function (option) { return option.value === value; })) {
          select.value = value;
        }
      });
      syncOptionButtons();
    }

    function updateOptionAvailability(service, variant) {
      var selections = selectionsObject(service);
      optionSelects.forEach(function (select) {
        var index = Number(select.dataset.optionIndex);
        Array.prototype.forEach.call(select.options, function (option) {
          var possible = variants.some(function (candidate) {
            if (candidate.available === false || !matchesService(candidate, service)) return false;
            if (normalise(getVariantOption(candidate, index)) !== normalise(option.value)) return false;
            return matchesSelections(candidate, selections, index);
          });
          option.disabled = !possible && option.value !== select.value;
        });
        select.setAttribute('aria-invalid', variant ? 'false' : 'true');
      });
      syncOptionButtons();
    }

    function updateEnhancedRepairOptionPrices(service) {
      if (!enhancedRepairOptions || service === 'exchange') return;
      var selections = selectionsObject(service);
      var controls = Array.prototype.slice.call(root.querySelectorAll('[data-rmx-option-buttons]'));
      controls.forEach(function (control) {
        var index = Number(control.dataset.optionIndex);
        var buttons = Array.prototype.slice.call(control.querySelectorAll('[data-rmx-enhanced-repair-option="true"]'));
        if (!buttons.length) return;
        var priced = buttons.map(function (button) {
          var value = button.dataset.value || '';
          var candidates = variants.filter(function (variant) {
            if (!matchesService(variant, service)) return false;
            if (normalise(getVariantOption(variant, index)) !== normalise(value)) return false;
            return Object.keys(selections).every(function (selectionIndex) {
              if (Number(selectionIndex) === index) return true;
              return normalise(getVariantOption(variant, Number(selectionIndex))) === normalise(selections[selectionIndex]);
            });
          });
          var available = candidates.filter(function (variant) { return variant.available !== false; });
          if (available.length) candidates = available;
          var lowest = candidates.reduce(function (best, variant) {
            return !best || Number(variant.price) < Number(best.price) ? variant : best;
          }, null);
          return { button: button, variant: lowest };
        });
        var basePrice = priced.reduce(function (lowest, item) {
          if (!item.variant) return lowest;
          var price = Number(item.variant.price) || 0;
          return lowest == null || price < lowest ? price : lowest;
        }, null);
        priced.forEach(function (item) {
          var target = item.button.querySelector('[data-rmx-option-price-delta]');
          if (!target) return;
          if (!item.variant || basePrice == null) {
            target.textContent = 'Unavailable';
            return;
          }
          var delta = (Number(item.variant.price) || 0) - basePrice;
          target.textContent = delta > 0 ? '+' + money(delta, currency, locale) : 'Included';
        });
      });
    }

    function variantForService(service) {
      var selections = selectionsObject(service);
      var exact = exactVariant(service, selections);
      if (exact) return exact;
      return bestVariant(service, selections, null);
    }

    function updateServiceCards(activeService) {
      serviceCards.forEach(function (card) {
        var service = card.dataset.service || 'repair';
        var variant = (lookupRequired && service === 'exchange' && selectedLookupGroup)
          ? variantForLookupGroup(selectedLookupGroup)
          : (lookupRequired && service === 'exchange' ? lowestPricedVariant('exchange') : variantForService(service));
        var active = service === activeService;
        var price = card.querySelector('[data-rmx-service-price-main]');
        card.classList.toggle('is-active', active);
        card.setAttribute('aria-checked', active ? 'true' : 'false');
        card.dataset.unavailable = (!variant || variant.available === false) ? 'true' : 'false';
        card.disabled = !variants.some(function (candidate) { return matchesService(candidate, service) && candidate.available !== false; });
        if (price) {
          var prefix = lookupRequired && service === 'exchange' && !selectedLookupGroup && variant ? 'From ' : '';
          price.textContent = variant ? prefix + money(variant.price, currency, locale) : (root.dataset.soldOutText || 'Unavailable');
        }
      });
    }

    function updateCollection(service) {
      if (!collectionWrap) return;
      var scope = collectionWrap.dataset.serviceScope || 'repair';
      var visible = scope === 'all' || service === 'repair';
      collectionWrap.classList.toggle('is-route-hidden', !visible);
      collectionWrap.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (!visible) {
        var enable = collectionWrap.querySelector('[data-rmx-ca-enable]');
        if (enable && enable.checked) {
          enable.checked = false;
          enable.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function collectionEnabled() {
      var enable = collectionWrap ? collectionWrap.querySelector('[data-rmx-ca-enable]') : null;
      return Boolean(enable && enable.checked && !collectionWrap.classList.contains('is-route-hidden'));
    }

    function updateRouteBadge(service) {
      var routeMode = serviceCount > 1 ? 'mixed' : service;
      if (galleryRoute && section) {
        var label = section.dataset.galleryRepairLabel || 'Repair your original unit';
        if (routeMode === 'exchange') label = section.dataset.galleryExchangeLabel || 'Replacement exchange unit';
        if (routeMode === 'mixed') label = section.dataset.galleryMixedLabel || 'Repair or exchange available';
        if (routeMode === 'standard') label = section.dataset.galleryStandardLabel || 'Available to order';
        galleryRoute.textContent = label;
      }
      galleryRouteIcons.forEach(function (icon) {
        icon.hidden = icon.dataset.rmxGalleryRouteIcon !== routeMode;
      });
    }

    function updateProcessRoute(service) {
      if (!processRoutes.length) return;
      processRoutes.forEach(function (route) {
        var routeName = route.dataset.rmxProcessRoute || 'standard';
        route.hidden = routeName !== service;
      });
    }

    function updateSku(variant) {
      if (!sku) return;
      sku.textContent = variant && variant.sku ? variant.sku : (root.dataset.noSkuText || 'SKU unavailable');
      var wrap = sku.closest('[data-rmx-sku-wrap]');
      if (wrap) wrap.hidden = !(variant && variant.sku);

      if (collectionWrap) {
        var addon = collectionWrap.querySelector('[data-rmx-collection-addon]');
        var partNumber = collectionWrap.querySelector('[data-rmx-ca-part-number]');
        if (addon) addon.dataset.productSku = variant && variant.sku ? variant.sku : '';
        if (partNumber && (!partNumber.dataset.userEdited || partNumber.dataset.userEdited === 'false')) {
          partNumber.value = variant && variant.sku ? variant.sku : '';
        }
      }
    }

    function updateUrl(variant) {
      if (!variant || !variant.id || root.dataset.updateUrl !== 'true' || !window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    function emitVariantChange(variant) {
      if (!variant || !section) return;
      var eventVariant = Object.assign({}, variant);
      if (!eventVariant.featured_media && eventVariant.featured_image && eventVariant.featured_image.id) {
        eventVariant.featured_media = { id: eventVariant.featured_image.id };
      }
      section.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: {
          form: form,
          variant: eventVariant,
          selectedOptions: optionSelects.map(function (select) { return select.value; })
        }
      }));
    }

    function normaliseLookup(value) {
      return String(value == null ? '' : value).toUpperCase().replace(/[^A-Z0-9]/g, '');
    }

    function aliasesForGroup(group) {
      var aliases = Array.isArray(group && group.aliases) ? group.aliases.slice() : [];
      if (group && group.group) aliases.unshift(group.group);
      return aliases.filter(Boolean);
    }

    function variantForLookupGroup(group) {
      if (!group) return null;

      if (group.variantId != null && String(group.variantId) !== '') {
        var linkedVariant = variants.find(function (variant) {
          return String(variant.id) === String(group.variantId);
        }) || null;
        if (linkedVariant) return linkedVariant;
      }

      // Generic safe fallback for simple Repair / Exchange products.
      // A non-empty stock pool marks the compatibility group as exchange-capable.
      // Only fall back when this product has exactly ONE Exchange/Replacement variant.
      // Products such as the BMW amplifier have multiple Exchange variants, so they
      // continue to require their explicit linked variant and are unaffected.
      // Information-only groups have no stock pool and can never use this fallback.
      if (group.stockPool) {
        var exchangeVariants = variants.filter(function (variant) {
          return matchesService(variant, 'exchange');
        });
        if (exchangeVariants.length === 1) return exchangeVariants[0];
      }

      return null;
    }

    function isInfoOnlyLookupGroup(group) {
      return Boolean(group && !variantForLookupGroup(group) && String(group.info || '').trim());
    }

    function lowestPricedVariant(service) {
      var candidates = variants.filter(function (variant) {
        return matchesService(variant, service) && variant.available !== false;
      });
      if (!candidates.length) {
        candidates = variants.filter(function (variant) { return matchesService(variant, service); });
      }
      if (!candidates.length) return null;
      return candidates.reduce(function (lowest, variant) {
        return !lowest || Number(variant.price) < Number(lowest.price) ? variant : lowest;
      }, null);
    }

    function updateLookupProperties(service) {
      var enabled = service === 'exchange' && Boolean(selectedLookupGroup);
      var hasGenericDetail = Boolean(selectedLookupGroup && selectedLookupGroup.detailLabel && selectedLookupGroup.detailValue);
      var detailValue = hasGenericDetail ? selectedLookupGroup.detailLabel + ': ' + selectedLookupGroup.detailValue : '';
      var asdValue = !hasGenericDetail && selectedLookupGroup && selectedLookupGroup.asd === true ? 'Yes' : !hasGenericDetail && selectedLookupGroup && selectedLookupGroup.asd === false ? 'No' : '';
      [[lookupPropertyGroup, selectedLookupGroup ? selectedLookupGroup.group : ''],
       [lookupPropertyReference, selectedLookupReference],
       [lookupPropertyDetail, detailValue],
       [lookupPropertyAsd, asdValue]].forEach(function (pair) {
        if (!pair[0]) return;
        pair[0].value = pair[1] || '';
        pair[0].disabled = !enabled || !pair[1];
      });
    }

    function clearSelectionDetails() {
      if (selectionDetails) selectionDetails.hidden = true;
      if (selectionReference) selectionReference.textContent = '';
      if (selectionSystem) { selectionSystem.textContent = ''; selectionSystem.hidden = true; }
      if (selectionAsd) { selectionAsd.textContent = ''; selectionAsd.hidden = true; }
      if (selectionNumbersWrap) { selectionNumbersWrap.hidden = true; selectionNumbersWrap.open = false; }
      if (selectionNumbers) selectionNumbers.innerHTML = '';
    }

    function clearLookupSelection(keepInput) {
      selectedLookupGroup = null;
      selectedLookupReference = '';
      if (!keepInput && lookupInput) lookupInput.value = '';
      clearSelectionDetails();
      updateLookupProperties(currentService());
    }

    function renderSelectionDetails(group, reference) {
      if (!group || !selectionDetails) {
        clearSelectionDetails();
        return;
      }
      var aliases = aliasesForGroup(group).filter(function (value, index, array) {
        return normaliseLookup(value) !== normaliseLookup(group.group) && array.indexOf(value) === index;
      });
      var hasGenericDetail = Boolean(group.detailLabel && group.detailValue);
      var asdKnown = group.asd === true || group.asd === false;
      if (selectionReference) selectionReference.textContent = reference || group.group || '';
      if (selectionSystem) {
        selectionSystem.textContent = group.system || '';
        selectionSystem.hidden = !group.system;
      }
      if (selectionAsd) {
        selectionAsd.textContent = hasGenericDetail
          ? group.detailLabel + ': ' + group.detailValue
          : (asdKnown ? (group.asd ? 'ASD integrated' : 'No integrated ASD') : '');
        selectionAsd.hidden = !(hasGenericDetail || asdKnown);
      }
      if (selectionNumbersWrap) {
        selectionNumbersWrap.hidden = group.showCompatible === false || !aliases.length;
        selectionNumbersWrap.open = false;
      }
      if (selectionNumbers) {
        selectionNumbers.innerHTML = '';
        aliases.forEach(function (alias) {
          var span = document.createElement('span');
          span.textContent = alias;
          selectionNumbers.appendChild(span);
        });
      }
      selectionDetails.hidden = false;
    }

    function selectLookupGroup(group, reference) {
      if (!group) return;
      selectedLookupGroup = group;
      selectedLookupReference = reference || group.group || '';
      if (lookupInput) lookupInput.value = selectedLookupReference;
      if (lookupSuggestions) lookupSuggestions.hidden = true;
      if (lookupSuggestionList) lookupSuggestionList.innerHTML = '';
      if (lookupStatus) {
        var infoOnly = isInfoOnlyLookupGroup(group);
        lookupStatus.textContent = infoOnly ? String(group.info || '').trim() : '';
        lookupStatus.hidden = !lookupStatus.textContent;
      }
      setLookupExpanded(false);
      renderSelectionDetails(group, selectedLookupReference);
      updateLookupProperties(currentService());
      update(null);
    }

    function lookupMatches(query) {
      var needle = normaliseLookup(query);
      if (!needle) return [];
      return exchangeGroups.map(function (group) {
        var aliases = aliasesForGroup(group);
        var exactAlias = aliases.find(function (alias) { return normaliseLookup(alias) === needle; });
        var starts = aliases.some(function (alias) { return normaliseLookup(alias).indexOf(needle) === 0; });
        var contains = aliases.some(function (alias) { return normaliseLookup(alias).indexOf(needle) !== -1; });
        return { group: group, exactAlias: exactAlias || '', rank: exactAlias ? 0 : starts ? 1 : contains ? 2 : 99 };
      }).filter(function (item) { return item.rank < 99; }).sort(function (a, b) {
        if (a.rank !== b.rank) return a.rank - b.rank;
        return String(a.group.group || '').localeCompare(String(b.group.group || ''));
      });
    }

    function bestDisplayAlias(group, query) {
      var aliases = aliasesForGroup(group).filter(function (alias) {
        return normaliseLookup(alias) !== normaliseLookup(group.group);
      });
      var needle = normaliseLookup(query);
      var groupNeedle = normaliseLookup(group && group.group);

      // If the customer is searching by amplifier model (for example BEB220,
      // BEB2, BE9510), do not append an arbitrary BMW part number. The model
      // itself is the thing that matched. Only show a part-number reference
      // when the search text actually matches one of the part-number aliases.
      if (!needle) return '';
      if (groupNeedle && (groupNeedle.indexOf(needle) !== -1 || needle.indexOf(groupNeedle) !== -1)) return '';

      var exact = aliases.find(function (alias) { return normaliseLookup(alias) === needle; });
      if (exact) return exact;
      var starts = aliases.find(function (alias) { return normaliseLookup(alias).indexOf(needle) === 0; });
      if (starts) return starts;
      var contains = aliases.find(function (alias) { return normaliseLookup(alias).indexOf(needle) !== -1; });
      if (contains) return contains;
      return '';
    }

    function setLookupExpanded(expanded) {
      if (lookupInput) lookupInput.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function hideLookupSuggestions() {
      if (!lookupSuggestions) return;
      lookupSuggestions.hidden = true;
      if (lookupStatus) {
        lookupStatus.textContent = '';
        lookupStatus.hidden = true;
      }
      setLookupExpanded(false);
    }

    function renderLookupSuggestions(query, showAll) {
      if (!lookupSuggestions) return;
      var list = lookupSuggestionList || lookupSuggestions;
      var needle = normaliseLookup(query);
      list.innerHTML = '';

      var matches = needle ? lookupMatches(query) : (showAll ? exchangeGroups.map(function (group) {
        return { group: group, exactAlias: '', rank: 3 };
      }) : []);

      var exact = needle ? matches.find(function (item) { return item.rank === 0; }) : null;

      // Searching/reopening is non-destructive. Keep the currently confirmed
      // exchange selection active until the customer explicitly clicks/taps
      // a different valid result.
      if (!matches.length) {
        if (lookupStatus) {
          lookupStatus.textContent = needle ? 'No matching exchange unit found. Check the number or contact us before ordering.' : '';
          lookupStatus.hidden = !needle;
        }
        lookupSuggestions.hidden = !needle;
        setLookupExpanded(Boolean(needle));
        update(null);
        return;
      }

      if (lookupStatus) {
        lookupStatus.textContent = needle
          ? (exact ? 'Exact match — select below to confirm' : (matches.length === 1 ? '1 possible match — select below to confirm' : matches.length + ' possible matches'))
          : '';
        lookupStatus.hidden = !lookupStatus.textContent;
      }
      matches.forEach(function (item) {
        var group = item.group;
        var matchedAlias = bestDisplayAlias(group, query);
        var variant = variantForLookupGroup(group);
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'rmx-exchange-lookup__suggestion';
        button.setAttribute('role', 'option');

        var copy = document.createElement('span');
        copy.className = 'rmx-exchange-lookup__suggestion-copy';
        var model = document.createElement('strong');
        model.textContent = [group.group || 'Exchange unit', matchedAlias].filter(Boolean).join(' · ');
        var detail = document.createElement('small');
        var genericDetail = group.detailLabel && group.detailValue ? group.detailLabel + ': ' + group.detailValue : '';
        var asd = !genericDetail && group.asd === true ? 'ASD integrated' : !genericDetail && group.asd === false ? 'No integrated ASD' : '';
        detail.textContent = [group.system || '', genericDetail || asd].filter(Boolean).join(' · ');
        copy.appendChild(model);
        if (detail.textContent) copy.appendChild(detail);

        var price = document.createElement('span');
        price.className = 'rmx-exchange-lookup__suggestion-price';
        var infoOnly = isInfoOnlyLookupGroup(group);
        var unavailable = !variant || variant.available === false;
        if (infoOnly) {
          price.textContent = '';
          button.addEventListener('click', function () {
            selectLookupGroup(group, matchedAlias || group.group || query);
            hideLookupSuggestions();
          });
        } else if (unavailable) {
          price.textContent = 'Out of stock';
          price.classList.add('is-unavailable');
          button.classList.add('is-unavailable');
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.title = 'This exchange unit is currently out of stock';
        } else {
          price.textContent = money(variant.price, currency, locale) + ' + VAT';
          button.addEventListener('click', function () {
            selectLookupGroup(group, matchedAlias || group.group || query);
            hideLookupSuggestions();
          });
        }

        button.appendChild(copy);
        button.appendChild(price);
        list.appendChild(button);
      });
      lookupSuggestions.hidden = false;
      setLookupExpanded(true);
      update(null);
    }

    function updateLookupVisibility(service) {
      if (!exchangeLookup) return;
      var visible = service === 'exchange';
      exchangeLookup.hidden = !visible;
      exchangeLookup.setAttribute('aria-hidden', visible ? 'false' : 'true');
      updateLookupProperties(service);
    }

    function updateButton(variant, service) {
      var infoOnly = service === 'exchange' && isInfoOnlyLookupGroup(selectedLookupGroup);
      var unavailable = !variant || variant.available === false;
      var needsLookup = lookupRequired && service === 'exchange' && !selectedLookupGroup;
      var needsConfirmation = service === 'repair' && requireRepairConfirm && confirmInput && !confirmInput.checked;
      var label = root.dataset.standardButtonText || 'Add to basket';
      if (service === 'repair') label = root.dataset.repairButtonText || 'Add repair service to basket';
      if (service === 'exchange') label = root.dataset.exchangeButtonText || 'Add exchange unit to basket';
      if (collectionEnabled() && service === 'repair') label = 'Add repair + collection to basket';
      if (collectionEnabled() && service !== 'repair') label = 'Add service + collection to basket';

      if (addButton) addButton.disabled = infoOnly || unavailable || needsConfirmation || needsLookup;
      if (addLabel) {
        addLabel.textContent = needsLookup
          ? 'Select your exchange unit above'
          : infoOnly
            ? 'Not available for exchange'
            : unavailable
              ? (root.dataset.soldOutText || 'Unavailable')
              : needsConfirmation
                ? (root.dataset.confirmText || 'Confirm repair service above')
                : label;
      }
    }

    function updateSelection(variant, service) {
      var optionValues = ((enhancedRepairOptions && service === 'exchange') || (optionVisibilityScope === 'exchange' && service !== 'exchange'))
        ? []
        : optionSelects.map(function (select) {
            if (!select.value) return '';
            if (!enhancedRepairOptions || service === 'exchange') return select.value;
            var label = optionSelects.length === 1 && repairOptionLabel ? repairOptionLabel : (select.dataset.optionName || 'Repair option');
            return label + ': ' + select.value;
          }).filter(Boolean);
      var infoOnly = service === 'exchange' && isInfoOnlyLookupGroup(selectedLookupGroup);
      var label = infoOnly ? 'Identified unit' : serviceLabel(service);
      if (lookupRequired && service === 'exchange') {
        optionValues = selectedLookupGroup ? [selectedLookupGroup.group || selectedLookupReference].filter(Boolean) : ['Select your unit'];
      }
      if (selectionText) selectionText.textContent = [label].concat(optionValues).join(' · ');
      var awaitingLookup = lookupRequired && service === 'exchange' && !selectedLookupGroup;
      var displayVariant = awaitingLookup ? lowestPricedVariant('exchange') : variant;
      var pricePrefix = awaitingLookup && displayVariant ? 'From ' : '';
      if (service === 'exchange' && selectedLookupGroup) renderSelectionDetails(selectedLookupGroup, selectedLookupReference);
      else clearSelectionDetails();
      if (selectionPrice) selectionPrice.textContent = displayVariant ? pricePrefix + money(displayVariant.price, currency, locale) + ' + VAT' : '';
      if (priceMain) priceMain.textContent = displayVariant ? pricePrefix + money(displayVariant.price, currency, locale) : '';
      if (priceInc) priceInc.textContent = displayVariant ? pricePrefix + money(Math.round(displayVariant.price * (1 + vatRate)), currency, locale) + ' inc. VAT' : '';
      if (stock) {
        var available = Boolean(variant && variant.available !== false);
        stock.dataset.available = available ? 'true' : 'false';
        stock.textContent = awaitingLookup
          ? 'Select your unit'
          : infoOnly
            ? 'Not available for exchange'
            : available ? (root.dataset.availableText || 'Available to order') : (root.dataset.unavailableText || 'Currently unavailable');
      }
    }

    function setConfirmationState(service) {
      if (confirmWrap) {
        confirmWrap.hidden = service !== 'repair';
        if (service !== 'repair' || (confirmInput && confirmInput.checked)) confirmWrap.classList.remove('has-error');
      }
      if (confirmationProperty) {
        var confirmed = service === 'repair' && (!requireRepairConfirm || (confirmInput && confirmInput.checked));
        confirmationProperty.value = confirmed
          ? 'Confirmed - customer understands this is a repair service and is sending their original unit'
          : '';
        confirmationProperty.disabled = !confirmed;
      }
    }

    function update(changedIndex) {
      var service = currentService();
      var selections = selectionsObject(service);
      var variant = null;
      if (lookupRequired && service === 'exchange') {
        variant = variantForLookupGroup(selectedLookupGroup);
      } else {
        variant = bestVariant(service, selections, changedIndex);
        if (variant && !exactVariant(service, selections)) syncSelectsToVariant(variant);
      }
      selectedVariant = variant;

      updateServiceCards(service);
      updateExtraOptionsVisibility(service);
      updateLookupVisibility(service);
      updateOptionAvailability(service, variant);
      updateEnhancedRepairOptionPrices(service);
      setConfirmationState(service);
      updateCollection(service);
      updateRouteBadge(service);
      updateProcessRoute(service);
      updateSelection(variant, service);
      updateButton(variant, service);
      updateSku(variant);

      if (idInput) idInput.value = variant && variant.id ? variant.id : '';
      root.dataset.selectedService = service;
      root.dataset.selectedVariantId = variant && variant.id ? String(variant.id) : '';
      updateUrl(variant);
      emitVariantChange(variant);
    }

    serviceCards.forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled) return;
        serviceCards.forEach(function (candidate) { candidate.classList.remove('is-active'); });
        card.classList.add('is-active');
        update(null);
      });
    });

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () { update(Number(select.dataset.optionIndex)); });
    });

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        var select = selectForIndex(button.dataset.optionIndex);
        if (!select) return;
        select.value = button.dataset.value || '';
        update(Number(button.dataset.optionIndex));
      });
    });

    if (lookupInput) {
      lookupInput.addEventListener('input', function () {
        // Searching is non-destructive: keep the currently confirmed exchange
        // selection active until the customer explicitly clicks another result.
        renderLookupSuggestions(lookupInput.value, true);
      });
      lookupInput.addEventListener('focus', function () {
        renderLookupSuggestions(lookupInput.value, true);
      });
      lookupInput.addEventListener('click', function () {
        renderLookupSuggestions(lookupInput.value, true);
      });
      lookupInput.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') hideLookupSuggestions();
      });
    }
    if (lookupToggle) {
      lookupToggle.addEventListener('click', function () {
        if (!lookupSuggestions) return;
        if (lookupSuggestions.hidden) {
          renderLookupSuggestions(lookupInput ? lookupInput.value : '', true);
          if (lookupInput) lookupInput.focus({ preventScroll: true });
        } else {
          hideLookupSuggestions();
        }
      });
    }
    document.addEventListener('click', function (event) {
      if (!exchangeLookup) return;
      // Keep the panel open only while interacting with the actual combobox/results.
      // Clicking elsewhere — including elsewhere inside the exchange section — closes it.
      if (lookupControl && lookupControl.contains(event.target)) return;
      hideLookupSuggestions();
    });

    if (confirmInput) confirmInput.addEventListener('change', function () { update(null); });

    if (form) {
      form.querySelectorAll('[data-rmx-qty-minus], [data-rmx-qty-plus]').forEach(function (button) {
        button.addEventListener('click', function () {
          var value = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1);
          value += button.hasAttribute('data-rmx-qty-minus') ? -1 : 1;
          if (quantityInput) quantityInput.value = Math.max(1, value);
        });
      });
      if (quantityInput) quantityInput.addEventListener('change', function () {
        quantityInput.value = Math.max(1, parseInt(quantityInput.value || '1', 10) || 1);
      });

      form.addEventListener('rmx:collection-toggle', function () { updateButton(selectedVariant, currentService()); });
      form.addEventListener('submit', function (event) {
        var service = currentService();
        var needsLookup = lookupRequired && service === 'exchange' && !selectedLookupGroup;
        var needsConfirmation = service === 'repair' && requireRepairConfirm && confirmInput && !confirmInput.checked;
        if (!needsLookup && !needsConfirmation) return;
        event.preventDefault();
        if (needsLookup && lookupInput) {
          if (lookupStatus) lookupStatus.textContent = 'Enter your unit details and select the matching exchange unit.';
          lookupInput.focus({ preventScroll: false });
          return;
        }
        if (confirmWrap) confirmWrap.classList.add('has-error');
        confirmInput.focus({ preventScroll: false });
      }, true);
    }

    if (collectionWrap) {
      var partNumber = collectionWrap.querySelector('[data-rmx-ca-part-number]');
      if (partNumber) {
        partNumber.dataset.userEdited = 'false';
        partNumber.addEventListener('input', function () { partNumber.dataset.userEdited = 'true'; });
      }
      var enable = collectionWrap.querySelector('[data-rmx-ca-enable]');
      if (enable) enable.addEventListener('change', function () { updateButton(selectedVariant, currentService()); });
    }

    if (lookupRequired && currentService() === 'exchange' && idInput && idInput.value) {
      selectedLookupGroup = exchangeGroups.find(function (group) { return String(group.variantId) === String(idInput.value); }) || null;
      if (selectedLookupGroup) {
        selectedLookupReference = selectedLookupGroup.group || '';
        if (lookupInput) lookupInput.value = selectedLookupReference;
        renderSelectionDetails(selectedLookupGroup, selectedLookupReference);
      }
    }

    update(null);
  }

  function initExactFitmentDisclosure(root) {
    if (!root || root.dataset.rmxFitmentInitialised === 'true') return;
    root.dataset.rmxFitmentInitialised = 'true';

    // Pass 213: preserve the convenient all-visible mobile treatment for small
    // fitment lists, but keep large lists compact. Large lists expand into a
    // bounded scroll area instead of making the product page excessively tall.
    try {
      if (window.matchMedia) {
        var mobileFitments = window.matchMedia('(max-width: 990px)');
        var fitmentCount = Number.parseInt(root.dataset.rmxFitmentCount || '0', 10);
        var isLargeFitmentList = root.classList.contains('rmx-fitment-card__more--large') || fitmentCount > 8;
        var syncFitmentDisclosure = function () {
          if (mobileFitments.matches && !isLargeFitmentList) root.open = true;
        };
        syncFitmentDisclosure();
        if (mobileFitments.addEventListener) mobileFitments.addEventListener('change', syncFitmentDisclosure);
        else if (mobileFitments.addListener) mobileFitments.addListener(syncFitmentDisclosure);
      }
    } catch (error) {}
  }

  function initFitmentScrollCue(root) {
    if (!root || root.dataset.rmxFitmentScrollInitialised === 'true') return;
    root.dataset.rmxFitmentScrollInitialised = 'true';

    var scroller = root.querySelector('[data-rmx-fitment-scroll]');
    var cue = root.querySelector('[data-rmx-fitment-scroll-cue]');
    if (!scroller || !cue) return;

    var syncCue = function () {
      var hasOverflow = scroller.scrollHeight > scroller.clientHeight + 2;
      var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 8;
      cue.classList.toggle('is-hidden', !hasOverflow || atBottom);
    };

    syncCue();
    scroller.addEventListener('scroll', syncCue, { passive: true });
    window.addEventListener('resize', syncCue, { passive: true });
    requestAnimationFrame(syncCue);
  }

  function initDetailNavigation(root) {
    if (!root || root.dataset.rmxDetailInitialised === 'true') return;
    root.dataset.rmxDetailInitialised = 'true';
    var links = Array.prototype.slice.call(root.querySelectorAll('[data-rmx-detail-link]'));
    var sections = Array.prototype.slice.call(root.querySelectorAll('[data-rmx-detail-section]'));
    if (!links.length || !sections.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      var visible = entries.filter(function (entry) { return entry.isIntersecting; })
        .sort(function (a, b) { return b.intersectionRatio - a.intersectionRatio; })[0];
      if (!visible) return;
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('href') === '#' + visible.target.id);
      });
    }, { rootMargin: '-24% 0px -62% 0px', threshold: [0, .15, .4] });

    sections.forEach(function (section) { observer.observe(section); });
  }

  function initAll(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-rmx-service-selector]').forEach(initServiceSelector);
    context.querySelectorAll('[data-rmx-fitment-more]').forEach(initExactFitmentDisclosure);
    context.querySelectorAll('[data-rmx-fitment-scroll-wrap]').forEach(initFitmentScrollCue);
    context.querySelectorAll('[data-rmx-detail-nav]').forEach(initDetailNavigation);
  }

  window.RmxProduct = window.RmxProduct || {};
  window.RmxProduct.init = initAll;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { if (event && event.target) initAll(event.target); });
  document.addEventListener('rmx:quickbuy:content', function (event) {
    initAll(event && event.detail && event.detail.root ? event.detail.root : document);
  });
})();


/* Pass 180: keep vehicle registrations clean while preserving non-UK/cherished formats. */
document.addEventListener('input', function (event) {
  var input = event.target && event.target.matches && event.target.matches('[data-rmx-vehicle-registration]') ? event.target : null;
  if (!input) return;
  var value = String(input.value || '')
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/^\s+/, '');
  if (input.value !== value) input.value = value;
});

document.addEventListener('change', function (event) {
  var input = event.target && event.target.matches && event.target.matches('[data-rmx-vehicle-registration]') ? event.target : null;
  if (!input) return;
  input.value = String(input.value || '').trim().replace(/\s+/g, ' ');
});
